import { Line } from '../block/Line'

export function saveClasses (entity) {
  if (Array.isArray(entity)) {
    return entity.map(saveClasses)
  } else if (entity != null && typeof entity === 'object') {
    if (entity.constructor.name === Line.name) {
      entity.__class = 'Line'
    } else {
      for (const key in entity) {
        if (entity.hasOwnProperty(key) && key !== '_prev') {
          entity[key] = saveClasses(entity[key])
        }
      }
    }
    return entity
  } else {
    return entity
  }
}

export function restoreClasses (entity) {
  if (Array.isArray(entity)) {
    return entity.map(restoreClasses)
  } else if (entity != null && typeof entity === 'object') {
    if ('__class' in entity && entity.__class === 'Line') {
      return Line.assign(entity.head)
    }

    for (const key in entity) {
      if (entity.hasOwnProperty(key)) {
        entity[key] = restoreClasses(entity[key])
      }
    }
    return entity
  } else {
    return entity
  }
}
